import { useState } from 'react';
import { useCart } from '../Contexts/Cart.contexts.jsx';
import './CheckOutPage.css';
// import { IoCaretBack } from "react-icons/io5";
import CheckOutBanner from '../PageElements/CartPageElements/checkOutBanner.jsx';

export default function CheckOutPage() {
    const { cartItems } = useCart();

    const price = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discount = price === 0 ? 0 : price > 3000 ? 300 : price > 2000 ? 200 : 100;
    const tax = Math.round(price * 0.05);

    const total = (price + tax - discount).toFixed(2);

    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        dob: '',
        gender: '',
        address: '',
        pincode: '',
        city: '',
        collectionType: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        console.log("Form Submitted:", {
            ...formData,
            cartItems,
            price,
            discount,
            tax,
            total
        });
    };

    return (
        <>
            <CheckOutBanner />
            <div className="checkoutContainer">

                <div className="checkoutFormSection">
                    <h2>Checkout</h2>
                    <form className="checkoutForm" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-row">
                            <input type="text" name="name" placeholder="Enter Your Name" value={formData.name} onChange={handleChange} required />
                            <input type="tel" name="mobile" placeholder="Your Mobile No" value={formData.mobile} onChange={handleChange} required />
                            <input type="email" name="email" placeholder="Your Email Id" value={formData.email} onChange={handleChange} required />
                        </div>

                        <div className="form-row">
                            <input type="date" name="dob" placeholder="Date of Birth" value={formData.dob} onChange={handleChange} required />
                            <div className="gender-block">
                                <label className="gender-label">Gender</label>
                                <div className="gender-options">
                                    {["Male", "Female", "Other"].map((g) => (
                                        <label key={g}>
                                            <input
                                                type="radio"
                                                name="gender"
                                                value={g}
                                                checked={formData.gender === g}
                                                onChange={handleChange}
                                            /> {g}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <textarea name="address" placeholder="Address" rows="3" value={formData.address} onChange={handleChange} required></textarea>

                        <div className="form-row">
                            <input type="text" name="pincode" placeholder="Pincode" value={formData.pincode} onChange={handleChange} required />
                            <input type="text" name="city" placeholder="Your City" value={formData.city} onChange={handleChange} required />
                        </div>

                        <div className="custom-dropdown highlighted-box">
                            <label htmlFor="collection-type" className="dropdown-label">
                                The package you have booked requires some sample collection. Do you want to opt for Home Collection or do you choose to visit our centre?
                            </label>
                            <div className="dropdown-wrapper">
                                <select
                                    id="collection-type"
                                    name="collectionType"
                                    value={formData.collectionType}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Location</option>
                                    <option value="home">🏠 Home Collection</option>
                                    <option value="centre">🏥 Visit Centre</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="checkoutSummarySection">
                    <div className="cart-total-card">
                        <h2 className="cart-title">Bill Summary</h2>
                        <div className="cart-row">
                            <span>M.R.P Total</span>
                            <span>₹{price.toFixed(2)}</span>
                        </div>
                        <div className="cart-row">
                            <span>Price Discount</span>
                            <span>- ₹{discount.toFixed(2)}</span>
                        </div>
                        <div className="cart-row">
                            <span>Tax</span>
                            <span>₹{tax.toFixed(2)}</span>
                        </div>
                        <hr />
                        <div className="cart-row total-row">
                            <span>TO BE PAID</span>
                            <span className="total-price">₹{total}</span>
                        </div>
                        <button className="checkout-button rbdButton" onClick={handleSubmit}><span className='btn-text'>Online Payment</span></button>
                        <button className="checkout-button rbdButton" ><span className='btn-text'>Pay at Clinic</span></button>
                    </div>
                </div>
            </div>
        </>
    );
}
